import React from 'react'
import { Link } from 'react-router-dom'
import './index.css'

interface PurpleLinkProps {
  linktext?: string;
  classes?: string;
  linkHolderStyles?: React.CSSProperties;
  linkStyles?: React.CSSProperties;
  to?: string;
  onClick?: () => void;
  [key: string]: any;
}

const PurpleLink: React.FC<PurpleLinkProps> = ({
  linktext = 'Click here',
  classes = '',
  linkHolderStyles = {},
  to = '/',
  onClick = () => {},
  ...restProps
}) => {
  return (
    <div className="link-holder-purple" style={linkHolderStyles}>
      <Link
        onClick={onClick}
        to={to}
        className={classes}
        {...restProps}
      >
        {linktext}
      </Link>
    </div>
  )
}

export default PurpleLink
